<template>
    <div>
        <!-- Show when Customer Record not exists -->
        <not-found
            v-if="!Object.keys(customerDetails).length && !showPageLoader"
        ></not-found>
        <!-- Show when Customer Record not exists -->

        <!-- When data is loading -->
        <base-table-spinner
            v-if="!Object.keys(customerDetails).length && showPageLoader"
        ></base-table-spinner>
        <!-- When data is loading -->

        <div
            v-if="Object.keys(customerDetails).length"
            class="card customer-info screen-section"
        >
            <customer-information
                profile-pic="image5.png"
                :customer-details="customerDetails"
            ></customer-information>
        </div>

        <div v-if="Object.keys(customerDetails).length" class="export-timeline">
            <b-button
                type="button"
                variant="secondary"
                :class="['secondary-add-btn']"
                @click="exportRecords"
            >
                <span class="btn-text">EXPORT TIMELINE</span>
            </b-button>
        </div>

        <!-- Activity Timeline -->
        <time-line
            v-if="Object.keys(customerDetails).length"
            :year-details="yearDetails"
        ></time-line>
        <!-- Activity Timeline -->

        <manual-alert-popup></manual-alert-popup>
        <cancel-review-process-popup></cancel-review-process-popup>
        <kyc-status-review-popup></kyc-status-review-popup>
        <export-process-popup
            :id="jobId"
            title="Export Activity Timeline"
            :url="cancelUrl"
        ></export-process-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import timeLine from '@/components/TimeLine.vue'
import manualAlertPopup from '@/components/popups/ManualAlertPopup.vue'
import customerInformation from '@/components/CustomerInfo.vue'
import kycStatusReviewPopup from '@/components/popups/KYCStatusReviewPopup.vue'
import exportProcessPopup from '@/components/popups/ExportProcessPopup.vue'
import cancelReviewProcessPopup from '@/components/popups/CancelReviewProcessPopup.vue'
import NotFound from '@/views/404/NotFound.vue'

import request from '@/utils/request'
import _ from 'lodash'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        customerInformation,
        kycStatusReviewPopup,
        cancelReviewProcessPopup,
        timeLine,
        exportProcessPopup,
        manualAlertPopup,
        NotFound,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            customerDetails: {},
            yearDetails: [],
            showPageLoader: true,
            jobId: null,
            cancelUrl: 'system-logs/cancel-export',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['profile', 'dataSegmentId']),
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.$router.push({ name: 'view-customer-profile' })
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.initializeData()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         *
         * @return {void}
         */
        async initializeData() {
            try {
                let { data } = await request({
                    url: `customers/activity-timeline/${this.id}`,
                })

                this.customerDetails = data.data
                this.yearDetails = _.orderBy(
                    this.customerDetails.activities,
                    ['_id'],
                    ['desc']
                )
            } catch (error) {
                console.log(error)
            }
            this.showPageLoader = false
        }, // End of initializeData() method
        async exportRecords() {
            try {
                let { data } = await request.post(
                    'customers/export-activity-timeline',
                    null,
                    {
                        params: {
                            customerId: this.$route.params.id,
                        },
                    }
                )

                this.jobId = data.data.id
                this.$store.commit(
                    'setTotalRecords',
                    _.sumBy(this.yearDetails, function (o) {
                        return o.describe.length
                    })
                )
                this.$bvModal.show('export-process-popup')
                this.$toasted.show(data.message, {
                    type: 'success',
                })
            } catch (error) {
                console.log(error, 'error')
            }
        },
    }, // End of Component > watch
} // End of export default
</script>
